import styled from 'styled-components';

export const DrawerContents = styled.div`
  padding: 60px 20px 20px 20px;
  width: 600px;
  height: 100%;
`;
DrawerContents.displayName = 'S.DrawerContents';
